import React, {useEffect, useState} from "react";
import Apicall from "./apicall";
import MovieRow from "./components/MovieRow";
import FeaturedMovie from "./components/FeaturedMovie";
import './App.css'
import apicall from "./apicall";
import Header from "./components/Header";
const App = () => {
    const [movieList, setMovieList] = useState([]);
    const [featuredData, setFeaturedData] = useState(null);
    const [blackHeader, setBlackHeader] = useState(false);
    useEffect(()=>{
        const loadall = async () => {
            let list = await Apicall.getHomeList();
            setMovieList(list);

            //get featured movie
            let originals = list.filter(i=>i.slug === 'originals');
            let randomChosen = Math.floor(Math.random()*(originals[0].items.results.length - 1))
            let chosen = originals[0].items.results[randomChosen]
            let chosenInfo = await apicall.getMovieInfo(chosen.id, 'tv')
            setFeaturedData(chosenInfo);

        }
        loadall();
    }, []);
    useEffect(()=>{
        const scrollListener = () => {
            if(window.scrollY > 10){
                setBlackHeader(true)
            }else{
                setBlackHeader(false)
            }
        }
        window.addEventListener('scroll', scrollListener)
        return () => {
            window.removeEventListener('scroll', scrollListener)
        }
    }, [])
    return (
        <div className='page'>
            <Header black={blackHeader}></Header>
            {featuredData &&
                <FeaturedMovie item={featuredData}></FeaturedMovie>
            }
            <section className='lists'>
                {movieList.map((item, key)=>(
                    <MovieRow key={key} title={item.title} items={item.items}/>
                ))}
            </section>
            <footer>
                Feito com <span role='img' aria-label='coração'>&#10084;&#65039;</span><br />
                Direitos de Imagem para Netflix<br />
                Base de dados do site <a>Themoviedb.org</a><br />
            </footer>
            {movieList.length <= 0 && 
            <div className="loading">
                <img src="https://media.filmelier.com/noticias/br/2020/03/Netflix_LoadTime.gif" alt="" />

            </div>
            }
        </div>
    );
}
export default App;